<template>
  <el-card>
    <el-form ref="searchForm" :model="searchForm" class="global-form" :inline="true">
      <el-form-item>
        <el-select v-model="searchForm.projectId" clearable placeholder="项目名称">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="dateArr" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" @change="dateChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="tips">
      <span>提示：包月/包工模式下的的人工成本，将在次月1号0点一次性计提到上月的成本中，如果发生变更，请提前修正。</span>
    </div>
    <div class="count">
      <div class="count-item">
        <span>人工成本总额（元）</span>
        <span>{{ count.personCostAmount }}</span>
      </div>
      <div class="count-item">
        <span>点工成本（元）</span>
        <span>{{ count.dgCostAmount }}</span>
      </div>
      <div class="count-item">
        <span>包工成本（元）</span>
        <span>{{ count.bgCostAmount }}</span>
      </div>
      <div class="count-item">
        <span>加班成本（元）</span>
        <span>{{ count.jbCostAmount }}</span>
      </div>
    </div>
    <div class="mb15">
      <el-button type="primary" @click="onExport">
        <div class="importExport">
          <icon name="xiazai"></icon>
          <span>导出</span>
        </div>
      </el-button>
    </div>
    <el-table ref="table" class="global-table" stripe v-loading="loading" :data="tableData">
      <el-table-column label="成本日期" prop="costDate" show-overflow-tooltip></el-table-column>
      <el-table-column label="所属项目" prop="projectName" show-overflow-tooltip></el-table-column>
      <el-table-column label="人工成本类型" prop="" show-overflow-tooltip>
        <template v-slot="{ row }">
          {{ laborCostTypeMap.get(row.costType) }}
        </template>
      </el-table-column>
      <el-table-column label="人工成本来源" prop="objectName" show-overflow-tooltip></el-table-column>
      <el-table-column label="成本金额（元）" prop="actualCostAmount" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="180px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetails(row)">查看</el-button>
          <el-button key="2" v-if="['2', '4'].includes(row.costType)" type="text" @click="onEdit(row)">编辑</el-button>
          <el-button key="3" v-if="['2', '4'].includes(row.costType)" type="text"
            @click="onDelete(row.reportId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <global-pagination :total="total" :current-page.sync="page" :page-size.sync="size" @current-change="loadData"
      @size-change="loadData"></global-pagination>

    <el-dialog :visible.sync="dialogVisible1" :close-on-click-modal="false" title="人工成本信息" width="1000px">
      <el-form class="global-form2" label-width="120px">
        <el-row>
          <el-col :span="8">
            <el-form-item :label="isWorker ? '工人姓名' : '班组名称'">
              <span>{{ formData.objectName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属项目">
              {{ formData.projectName }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="成本月份">
              {{ formatMonth }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="包工金额">
              {{ formData.originalCostAmount }} 元
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item v-if="!isWorker" label="最低用工数">
              {{ formData.minWorkerNum ?? '--' }} 人/天
            </el-form-item>
          </el-col>
          <el-col v-if="isWorker" :span="8">
            <el-form-item label="签到次数">
              {{ formData.signCount ?? '--' }} 人次
            </el-form-item>
          </el-col>
          <el-col v-else :span="8">
            <el-form-item label="签到人次">
              {{ formData.signPersonCount ?? '--' }} 人次
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-calendar :value="formData.costDate">
        <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
        <template v-slot:dateCell="{ date, data }">
          <div class="calenday-item">
            <span>
              {{ data.day.split('-').slice(1).join('-') }}
            </span>
            <span>{{ getCostAmount(data.day) }}</span>
          </div>
        </template>
      </el-calendar>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible2" :close-on-click-modal="false" title="人工成本信息" width="600px">
      <el-form :model="editForm" ref="form" :rules="rules" class="global-form2" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="isWorker ? '工人姓名' : '班组名称'">
              <span>{{ formData.objectName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="签到项目">
              {{ formData.projectName }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="成本月份">
              {{ formatMonth }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="包工金额">
              {{ formData.originalCostAmount }} 元
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item v-if="!isWorker" label="最低用工数">
              {{ formData.minWorkerNum ?? '--' }} 人/天
            </el-form-item>
          </el-col>
          <el-col v-if="isWorker" :span="24">
            <el-form-item label="签到次数">
              {{ formData.signCount ?? '--' }} 人次
            </el-form-item>
          </el-col>
          <el-col v-else :span="24">
            <el-form-item label="签到人次">
              {{ formData.signPersonCount ?? '--' }} 人次
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="actualCostAmount" label="实发金额">
              <el-input v-model="editForm.actualCostAmount" placeholder="请输入实发金额" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <el-button type="default" @click="dialogVisible2 = false">取消</el-button>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <WorkerDetails :detailsShow.sync="workerVisible" :id.sync="objectId"></WorkerDetails>
    <TeamsDetails :detailsShow.sync="teamVisible" :id.sync="objectId"></TeamsDetails>
    <ExtraworkListDetails :detailsShow.sync="extraworkVisible" :detailsId.sync="objectId"></ExtraworkListDetails>
  </el-card>
</template>

<script>
import FileUpload from '@/components/FileUpload.vue'
import { validTwoDecimal } from '@/utils/validate'
import { laborCostType } from '@/utils/dict'
import WorkerDetails from '@/views/setting/laborManage/attendance/WorkerDetails.vue'
import TeamsDetails from '@/views/setting/laborManage/attendance/TeamsDetails.vue'
import ExtraworkListDetails from '@/views/setting/laborManage/attendance/ExtraworkListDetails.vue'

export default {
  name: "LaborCost",
  components: {
    FileUpload,
    WorkerDetails,
    TeamsDetails,
    ExtraworkListDetails
  },
  data() {
    return {
      workerVisible: false,
      teamVisible: false,
      extraworkVisible: false,
      objectId: '',
      dateArr: [],
      laborCostTypeMap: laborCostType,
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
      dateRange: [],
      searchForm: {
        projectId: '',
        startTime: '',
        endTime: ''
      },
      count: {
        personCostAmount: '0', // 人成本总金额
        dgCostAmount: '0', // 点工成本金额
        bgCostAmount: '0', // 包工成本金额
        jbCostAmount: '0' // 加班成本金额
      },
      formData: {
        reportId: '', // 人工成本汇总ID
        projectId: '', // 项目ID
        costType: '', // 成本类型1工人点工2工人包月3班组点工4班组包工5工人加班6班组加班
        objectId: '', // 工人或班组ID
        objectName: '', // 工人或班组名称
        originalLaborPrice: '', // 初始劳务单价
        originalCostAmount: '', // 初始成本金额
        actualCostAmount: '', // 实际成本金额
        minWorkerType: '', // 最低用工类型1天2月
        costDate: '', // 成本日期
        minWorkerNum: '', // 最低用工数
        relId: '', // 关联业务ID
        signCount: '', // 签到次数
        projectName: '', // 项目名称
        signPersonCount: '', // 签到人数
        attendanceList: [] // 考勤明细
      },
      editForm: {
        reportId: '', // 人工成本汇总ID
        actualCostAmount: '' // 实际成本金额
      },
      rules: {
        actualCostAmount: [
          { required: true, message: '请输入实发金额' },
          { pattern: validTwoDecimal, message: '请输入正确的金额' }
        ]
      },
      dialogVisible1: false,
      dialogVisible2: false
    }
  },
  computed: {
    isWorker() {
      return ['1', '2', '5'].includes(this.formData.costType)
    },
    projectList() {
      return this.$store.state.projectList
    },
    formatMonth() {
      return this.$dayjs(this.formData.costDate).format('YYYY-MM')
    }
  },
  watch: {},
  created() {
    this.loadData()
    this.loadCount()
  },
  methods: {
    onExport() {
      const loading = this.$loading({
        lock: true,
        text: '下载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$axios.downloadFile(this.$apis.operate.exportData, this.searchForm).finally(() => {
        loading.close()
      })
    },
    loadCount() {
      this.$axios.get(this.$apis.operate.selectPersonCostTypeSum, this.searchForm).then(res => {
        this.count = res || {}
      })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.operate.selectPersonCostReportByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm,
      }).then((res) => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    calculateCalendarDates(year, month) {
      // 获取目标月份的第一天
      const firstDayOfMonth = this.$dayjs(`${year}-${month}-01`)
      // 获取目标月份第一天是星期几（1 表示周一，7 表示周日）
      const firstDayWeekday = firstDayOfMonth.day() || 7
      // 计算日历面板的第一天
      const firstDate = firstDayOfMonth.subtract(firstDayWeekday - 1, 'day')
      // 获取目标月份的最后一天
      const lastDayOfMonth = firstDayOfMonth.endOf('month')
      // 获取目标月份最后一天是星期几（1 表示周一，7 表示周日）
      const lastDayWeekday = lastDayOfMonth.day() || 7
      // 计算日历面板的最后一天
      const lastDate = lastDayOfMonth.add(7 - lastDayWeekday, 'day');
      return [firstDate.format('YYYY-MM-DD'), lastDate.format('YYYY-MM-DD')]
    },
    loadDetails(reportId) {
      return this.$axios.get(this.$apis.operate.selectPersonCostReportByReportId, {
        reportId
      }).then(res => {
        this.formData = res
      })
    },
    getCostAmount(day) {
      return this.formData.attendanceList.find(item => item.attendanceDate === day)?.signStatus
    },
    dateChange(date) {
      if (date) {
        this.searchForm.startTime = date[0]
        this.searchForm.endTime = date[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    },
    onSearch() {
      this.page = 1
      this.loadData()
      this.loadCount()
    },
    onEdit(row) {
      this.loadDetails(row.reportId).then(() => {
        this.editForm.reportId = row.reportId
        this.editForm.actualCostAmount = this.formData.actualCostAmount
        this.dialogVisible2 = true
      })
    },
    onDetails(row) {
      console.log('row.costType', row.costType)
      switch (row.costType) {
        case '1':
          this.workerVisible = true
          this.objectId = row.relId
          break
        case '3':
          this.teamVisible = true
          this.objectId = row.relId
          break
        case '2':
        case '4':
          this.loadDetails(row.reportId).then(() => {
            this.dialogVisible1 = true
          })
          break
        case '5':
        case '6':
          this.extraworkVisible = true
          this.objectId = row.relId
          break
        default:
          break
      }
    },
    onDelete(reportId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.operate.deletePersonCostReport, { reportId }).then(() => {
          this.$message.success('删除成功')
          this.loadData()
          this.loadCount()
        })
      })
    },
    onSubmit() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.operate.updatePersonCostReport
        this.$axios.post(url, this.editForm).then(() => {
          this.$message.success('提交成功')
          this.dialogVisible2 = false
          this.loadData()
          this.loadCount()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.tips {
  height: 32px;
  background: rgba(255, 228, 118, 0.3);
  display: flex;
  align-items: center;
  padding: 0 16px;
  margin-bottom: 20px;

  span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 22px;
    text-align: left;
    font-style: normal;
  }
}

.calenday-item {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  align-items: flex-end;
}

.el-calendar {
  ::v-deep {
    .el-calendar__header {
      display: none;
    }
  }
}

.count {
  display: flex;
  align-items: center;
  margin-bottom: 30px;

  .count-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 380px;
    height: 123px;
    border-radius: 8px;
    flex-shrink: 0;
    padding-left: 90px;

    &:nth-child(n + 2) {
      margin-left: 16px;
    }

    &:nth-child(1) {
      width: 457px;
      background: url(../../../../assets/img/operate/rg-icon1.png) no-repeat;
      background-size: 457px 123px;
    }

    &:nth-child(2) {
      background: url(../../../../assets/img/operate/rg-icon2.png) no-repeat;
      background-size: 380px 123px;
    }

    &:nth-child(3) {
      background: url(../../../../assets/img/operate/rg-icon3.png) no-repeat;
      background-size: 380px 123px;
    }

    &:nth-child(4) {
      background: url(../../../../assets/img/operate/rg-icon4.png) no-repeat;
      background-size: 380px 123px;
    }

    span {
      &:nth-child(1) {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 22px;
        color: #FFFFFF;
        line-height: 30px;
        text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
        text-align: left;
        font-style: normal;
      }

      &:nth-child(2) {
        font-family: DINAlternateBold;
        font-size: 30px;
        color: #FFFFFF;
        line-height: 38px;
        text-align: left;
        font-style: normal;
        margin-top: 10px;
      }
    }
  }
}
</style>
